import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API_URL = '/api/content';

const Resources = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const res = await fetch(`${API_URL}/blog`);
      const data = await res.json();
      if (Array.isArray(data)) {
        // Filter only featured articles for homepage
        const featured = data.filter(post => post.featured);
        setArticles(featured.slice(0, 3)); // Max 3 articles
      }
    } catch (err) {
      console.error('Error fetching articles:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  if (loading) {
    return (
      <section className="py-20 bg-white border-t border-gray-200">
        <div className="container mx-auto px-4 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600 mx-auto"></div>
        </div>
      </section>
    );
  }

  if (articles.length === 0) {
    return (
      <section className="py-20 bg-white border-t border-gray-200">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-6">
              <div className="flex-1 h-px bg-gray-300"></div>
              <h2 className="text-4xl font-bold text-gray-900 px-8">
                RESOURCES
              </h2>
              <div className="flex-1 h-px bg-gray-300"></div>
            </div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Insights, technical guides, and industry news to help you stay informed.
            </p>
          </div>
          
          <div className="text-center py-12">
            <p className="text-gray-500 mb-4">No featured articles yet.</p>
            <p className="text-sm text-gray-400">Go to Admin Dashboard → Blog to mark articles as featured.</p>
          </div>

          <div className="text-center mt-12">
            <Link 
              to="/blog"
              className="px-8 py-4 border-2 border-pink-600 text-pink-600 rounded-full font-semibold hover:bg-pink-600 hover:text-white transition-colors duration-300 inline-block"
            >
              View All Articles
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-white border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="flex-1 h-px bg-gray-300"></div>
            <h2 className="text-4xl font-bold text-gray-900 px-8">
              RESOURCES
            </h2>
            <div className="flex-1 h-px bg-gray-300"></div>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Insights, technical guides, and industry news to help you stay informed.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {articles.map((article) => (
            <Link 
              key={article.id} 
              to={`/blog/${article.id}`}
              className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer group"
            >
              {article.image ? (
                <div className="h-48 overflow-hidden">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
              ) : (
                <div className="h-48 bg-gray-200 border-2 border-dashed rounded-none" />
              )}
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-3 py-1 bg-pink-100 text-pink-700 text-xs font-medium rounded-full">
                    {article.category || 'Article'}
                  </span>
                  <span className="text-gray-400 text-sm">{formatDate(article.date)}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-pink-600 transition-colors">{article.title}</h3>
                <p className="text-gray-600 mb-4 line-clamp-2">{article.excerpt || article.content?.replace(/<[^>]*>/g, '').substring(0, 100)}</p>
                <div className="flex items-center justify-end">
                  <span className="text-pink-600 font-medium text-sm group-hover:underline">Read more →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/blog"
            className="px-8 py-4 border-2 border-pink-600 text-pink-600 rounded-full font-semibold hover:bg-pink-600 hover:text-white transition-colors duration-300 inline-block"
          >
            View All Articles
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Resources;
